<template>
  <div class="search">
    <button class="search-revoke" v-show="isSearchComplete" @click="cancelSearch">
      <span class="fal fa-undo search-revoke__icon"></span>
      검색 취소
    </button>

    <div class="search-bar" @keyup.down="hoverDown" @keyup.up="hoverUp">
      <label for="search-bar-input-address" class="blind">검색창</label>
      <input
        id="search-bar-input-address"
        type="text"
        autocomplete="off"
        maxlength="30"
        placeholder="주소 검색"
        v-on:input="typing"
        @focus="setIsSearchDropDownVisible(true)"
        v-model="searchString"
        v-on:keyup.enter="enterSearch"
      />

      <button class="search-button" type="button" @click="search('')" aria-label="검색">
        <i class="fal fa-search" aria-hidden="true"></i>
        <span class="blind">검색</span>
      </button>
    </div>

    <div class="search-dropdown" v-show="isSearchDropDownVisible && searchString" @mouseleave="setActiveIndex(-1)">
      <ul class="search-dropdown__menu">
        <li
          v-for="(searchBoxInfo, index) in searchBoxInfoList"
          :key="index"
          :class="activeIndex === index ? 'active' : null"
          @mouseover="setActiveIndex(index)"
        >
          <a class="search-dropdown__menu--row" @click="searchBoxInfo.clickFunc"
            >{{ searchBoxInfo.searchName }}: <span class="bold">{{ searchString }}</span></a
          >
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressSearchBox',
  data() {
    return {
      searchString: '',
      isSearchComplete: false,
      activeIndex: -1,
      searchBoxInfoList: [
        {
          searchName: '전체',
          clickFunc: () => this.search('all'),
        },
        {
          searchName: '이름',
          clickFunc: () => this.search('name'),
        },
        {
          searchName: '이메일',
          clickFunc: () => this.search('email'),
        },
        {
          searchName: '전화번호',
          clickFunc: () => this.search('phone'),
        },
        {
          searchName: '회사',
          clickFunc: () => this.search('company'),
        },
      ],
    };
  },
  props: {
    isSearchDropDownVisible: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    let self = this;
    let searchInfo = this.getHashObject(window.location.hash);
    if (searchInfo.search_word) {
      this.isSearchComplete = true;
      this.searchString = searchInfo.search_word;
    }
    window.hideCancelSearch = function() {
      self.hideCancelSearch();
    };
  },
  methods: {
    getHashObject: function(hash_string) {
      var vars = new Object();
      var hash;
      var hashes = this.decode(hash_string).split('&');
      for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');

        if (this.permitObjectValueName(hash[0])) vars[hash[0]] = hash[1];
      }
      return vars;
    },

    permitObjectValueName: function(str) {
      // 원치 않는 값이 들어가지 못하게 막는다
      var permitArr = [
        'countPerPage',
        'startPage',
        'order',
        'orderby',
        'chosung',
        'star',
        'kind',
        'tagNo',
        'search_word',
        'search_type',
        'itemsPerPage',
      ];
      return permitArr.includes(str);
    },
    decode: function decode(input) {
      var output = '';
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      var keyStr = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      input = input.replace(/[^A-Za-z0-9+/=]/g, '');

      while (i < input.length) {
        enc1 = keyStr.indexOf(input.charAt(i++));
        enc2 = keyStr.indexOf(input.charAt(i++));
        enc3 = keyStr.indexOf(input.charAt(i++));
        enc4 = keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);

        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }

        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }

      output = this._utf8_decode(output);
      return output;
    },
    _utf8_decode: function _utf8_decode(utftext) {
      var string = '';
      var i = 0;
      var c = 0,
        c2,
        c3 = 0;

      while (i < utftext.length) {
        c = utftext.charCodeAt(i);

        if (c < 128) {
          string += String.fromCharCode(c);
          i++;
        } else if (c > 191 && c < 224) {
          c2 = utftext.charCodeAt(i + 1);
          string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
          i += 2;
        } else {
          c2 = utftext.charCodeAt(i + 1);
          c3 = utftext.charCodeAt(i + 2);
          string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
          i += 3;
        }
      }

      return string;
    },
    hoverUp() {
      if (this.activeIndex <= 0) {
        return false;
      }
      this.activeIndex--;
    },
    hoverDown() {
      if (this.activeIndex >= this.searchBoxInfoList.length - 1) {
        return false;
      }
      this.activeIndex++;
    },
    setActiveIndex(index) {
      this.activeIndex = index;
    },
    typing(event) {
      if (event.target.value.length <= 0) {
        return false;
      }
      this.searchString = event.target.value;
      if (!this.isSearchDropDownVisible) {
        this.$emit('set-is-search-drop-down-visible', true);
      }
    },
    setIsSearchDropDownVisible(isVisible) {
      this.$emit('set-is-search-drop-down-visible', isVisible);
    },
    enterSearch() {
      if (this.activeIndex <= -1) {
        this.searchBoxInfoList[0].clickFunc();
      } else {
        this.searchBoxInfoList[this.activeIndex].clickFunc();
      }
    },
    search(type) {
      if (this.searchString.length < 2) {
        alert('2글자 이상 입력하세요.');
        return false;
      }
      this.isSearchComplete = true;
      this.setIsSearchDropDownVisible(false);
      window.AddrNewCommon.generateHashUrlSubmit(this.searchString, type);
    },
    cancelSearch() {
      window.AddrNewCommon.reset_search_word();
      this.hideCancelSearch();
    },
    hideCancelSearch() {
      this.isSearchComplete = false;
      this.setIsSearchDropDownVisible(false);
    },
  },
};
</script>
